<template>
  <div v-if="intent">
    <v-layout style="border-bottom: 1px solid #eee;" class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{
          errors.first('intentName')
          }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>
    <div class="pa-2">
      <template
        v-if="intent.answer.length > 0 && intent.answer[0].length > 0 && intent.answer[0][0].to"
      >
        <template v-for="(r, index) in intent.answer[0][0].to">
          <div :key="index" class="z-border-red pa-2 mb-2">
            <v-layout>
              <v-flex>Random {{ index + 1 }}</v-flex>
              <v-btn
                fab
                outline
                color="primary"
                small
                class="ma-0"
                @click="removeRandom(index)"
                :disabled=" intent.answer[0][0].to.length <= 2"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </template>
        <div
          class="add-conversation text-xs-center"
          style="cursor: pointer"
          @click="addRandom"
          v-if="intent.answer.length <= 10"
        >
          <i class="fa fa-plus middle"></i>
          {{ $t('Add random') }}
        </div>
      </template>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      excludedName: '',
      intent: null
    }
  },
  mounted() {
    this.intent = JSON.parse(JSON.stringify(this.value))
    if (
      this.intent.answer.length == 0 ||
      this.intent.answer[0].length == 0 ||
      !this.intent.answer[0][0].to
    ) {
      this.$set(this.intent, 'answer', [
        [
          {
            to: [0, 0],
            type: 'random'
          }
        ]
      ])

      //   this.$emit('input', this.intent)
    }
    this.cached_intent = JSON.stringify(this.intent)
  },
  methods: {
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('onCancel')
    },
    onSave() {
      this.cached_intent = JSON.stringify(this.intent)
      this.$emit('onSave', this.intent)
    },
    removeRandom(index) {
      this.intent.answer[0][0].to.splice(index, 1)

      //   this.$emit('input', this.intent)
    },
    addRandom() {
      this.intent.answer[0][0].to.push(0)

      //   this.$emit('input', this.intent)
    }
  },
  watch: {
    value() {
      this.intent = this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/RandomManage.vue